module.exports = __webpack_public_path__ + "img/code-jquery-sm.e1604bfa.webp";